var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"manager-container",attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('StandaloneDownloadCard')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }